type Keys<T> = keyof T;
type Values<T> = T[Keys<T>];

// 関心部分
// タグの辞書
export const TagIdToNameMap = {
  1: "新築",
  2: "中古",
  3: "借り換え",
  4: "資産形成",
  5: "居住用",
  6: "非公開物件",
  7: "節税",
  8: "相続",
  9: "査定",
  10: "管理会社",
  11: "確定申告",
  12: "その他",
} as const;

// タグの型
export type InterestedPropertyTypeId = number;
export type MasterAgentSearchTagId = number;
export type MasterTagNames = string;
export type MasterAgentSearchTagNames = string;
export type Tag = {
  id: InterestedPropertyTypeId;
  name: MasterTagNames;
};
export type AgentSearchTag = {
  id: MasterAgentSearchTagId;
  name: MasterAgentSearchTagNames;
};

export const TagNameToIdMap = Object.fromEntries(
  Object.entries(TagIdToNameMap).map((value) => [value[1], Number(value[0]) as InterestedPropertyTypeId])
);

// タグの配列
export const Tags: Tag[] = Object.entries(TagIdToNameMap).map(([id, name]) => {
  return { id: parseInt(id) as InterestedPropertyTypeId, name };
});

export const AllTagIds = Object.keys(TagIdToNameMap).map(Number) as InterestedPropertyTypeId[];
export const AllTagNames = Object.values(TagIdToNameMap).map(String) as MasterTagNames[];

// 職業部分
// タグの辞書
export const OccupationIdToNameMap = {
  1: "会社員（上場）",
  2: "会社員（非上場）",
  3: "会社員（外資系企業）",
  4: "会社役員",
  5: "公務員",
  6: "士業",
  7: "医師・歯科医師",
  8: "薬剤師・看護師",
  9: "自営業",
  10: "その他",
} as const;

// タグの型
export type OccupationTagId = Keys<typeof OccupationIdToNameMap>;
export type OccupationTagNames = Values<typeof OccupationIdToNameMap>;
export type OccupationTag = {
  id: OccupationTagId;
  name: OccupationTagNames;
};

export const OccupationTagNameToIdMap = Object.fromEntries(
  Object.entries(OccupationIdToNameMap).map((value) => [value[1], Number(value[0]) as OccupationTagId])
);

// タグの配列
export const OccupationTags: OccupationTag[] = Object.entries(OccupationIdToNameMap).map(([id, name]) => {
  return { id: parseInt(id) as OccupationTagId, name };
});

export const OccupationAllTagIds = Object.keys(OccupationIdToNameMap).map(Number) as OccupationTagId[];
export const OccupationAllTagNames = Object.values(OccupationIdToNameMap).map(String) as OccupationTagNames[];

// 業種部分
export const IndustryIdToNameMap = {
  1: "IT・通信系",
  2: "サービス系",
  3: "メーカー系(電気・機械)",
  4: "メーカー系(素材・医薬品他)",
  5: "メーカー系(自動車・輸送用機器)",
  6: "専門コンサル系",
  7: "商社系(電気・機械系)",
  8: "商社系(総合・素材・医薬品他)",
  9: "金融系",
  10: "不動産系",
  11: "建設系",
  12: "マスコミ系",
  13: "流通・小売系",
  14: "インターネット・Web業界",
  15: "ゲーム業界",
  16: "広告・マーケティング系",
  17: "教育・学校系",
  18: "医療・福祉系",
  19: "エネルギー・環境系",
  20: "官公庁・公共サービス系",
  21: "運輸・物流・倉庫系",
  22: "飲食・フード系",
  23: "その他",
} as const;

export type IndustryTagId = Keys<typeof IndustryIdToNameMap>;
export type IndustryTagNames = Values<typeof IndustryIdToNameMap>;

// 金融資産部分
export const FINANCIAL_ASSET_OPTIONS = [
  { value: 1, label: "なし" },
  // value: 5 — 既存値はDBに保存済みのため変更すると履歴が壊れる、後から追加した選択肢なため末尾採番
  { value: 5, label: "〜500万円" },
  { value: 2, label: "500〜1,000万円" },
  { value: 3, label: "1,000〜3,000万円" },
  { value: 4, label: "3,000万円〜" },
] as const;

export const FINANCIAL_ASSET_LABELS: Record<number, string> = Object.fromEntries(
  FINANCIAL_ASSET_OPTIONS.map((opt) => [opt.value, opt.label])
);
